import React from "react";
import DashboardLayout from "../DashboardLayout";
import AuthRouter from "../routes/AuthRouter";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { addAccessToken } from "../../features/AccessTokenSlice";
import useAuth from "../../hooks/useAuth";
import useCustomRouting from "../../hooks/useCustomRouting";
import SessionExpiry from "../SessionExpiry";

const AuthLayout = () => {
  const dispatch = useDispatch();
  const { redirectToPath } = useCustomRouting();
  const { token: localToken, handleSetToken } = useAuth();

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const urlParams = new URLSearchParams(hash.substring(1));
      const token = urlParams.get("access_token");
      if (token) {
        dispatch(addAccessToken(token));
        handleSetToken(token);
      }
    } else {
      const search = window.location.search;
      if (search) {
        const urlParams = new URLSearchParams(window.location.search);
        if (!localToken) {
          localStorage.setItem("urlParams", urlParams);
          redirectToPath("/login");
        }
      } else if (!localToken) redirectToPath("/login");
    }
  }, []);
  return (
    <DashboardLayout isTokenReady={!!localToken}>
      <AuthRouter />
      <SessionExpiry />
    </DashboardLayout>
  );
};

export default AuthLayout;
